var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEmpowerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.475342,
    y: 0.895508,
    width: 42.945,
    height: 42.945,
    rx: 2.68406,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72546 19.3146C5.13913 20.0795 4.85091 20.817 5.07381 21.8389H38.8795C39.0114 19.8909 38.4383 19.0123 36.1913 17.849C35.3317 12.3702 33.4993 10.2965 28.7785 6.8563C28.1627 6.40751 28.1223 6.38618 27.9639 6.8563C27.8056 7.32642 27.2308 11.5791 27.0679 11.9862C26.9049 12.3933 26.8235 12.4748 26.4162 12.4748C26.0089 12.4748 25.846 12.1491 25.7645 11.9862C25.6831 11.8234 25.7645 5.30918 25.7645 5.30918C25.409 4.39625 25.0373 4.04294 23.728 4.00635H19.3292C19.3292 4.00635 18.759 4.08777 18.4331 4.65776C18.1073 5.22775 18.1888 5.9606 18.1888 5.9606V11.9862C18.1888 11.9862 17.9444 12.4748 17.4556 12.4748C16.804 12.4748 16.7225 11.9862 16.7225 11.9862C16.7225 11.9862 16.0708 6.29795 15.8265 6.36773C15.2562 6.53059 13.7085 7.01915 10.776 10.1948C9.79844 11.2534 9.22822 12.1491 8.49509 14.0219C7.76195 15.8947 7.68052 17.849 7.68052 17.849C7.68052 17.849 6.87215 18.2479 6.4586 18.5818C6.04504 18.9157 5.72546 19.3146 5.72546 19.3146Z",
    fill: "url(#paint0_linear_1486_1752)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6045 24.2817H5.72546V25.8288C5.83535 26.3418 5.72546 26.8059 6.38335 27.1317L9.64172 27.5388L11.4276 31.203L9.39114 33.6458C9.06309 34.3128 9.13322 34.6627 9.39114 35.2744L11.4276 37.1472C12.0912 37.5345 12.4209 37.4735 12.9754 37.1472L15.4191 35.2744C16.5734 36.1048 17.428 36.3296 19.0848 36.5772L19.3292 39.4272C19.4535 40.2419 19.7011 40.4873 20.3067 40.73H23.5651C24.1885 40.4605 24.4052 40.1872 24.4611 39.4272L24.787 36.5772C26.3722 36.3426 27.1588 36.0076 28.3712 35.0301L31.1408 37.1472C31.6903 37.3992 32.0245 37.4227 32.6885 37.1472L34.5621 35.0301C34.7691 34.5456 34.7751 34.2445 34.5621 33.6458L32.6885 31.203L34.1548 27.3759L37.3317 27.1317C37.921 26.9836 38.1841 26.825 38.3092 26.1545V24.2817H29.0229C28.3162 29.3149 27.0741 31.773 22.0988 31.773C16.7287 31.773 15.4934 29.5639 14.6045 24.2817Z",
    fill: "url(#paint1_linear_1486_1752)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.966 42.1278L17.3912 38.8481C15.9522 38.4394 14.5556 37.8074 13.2446 36.95L12.9211 37.1928L12.8412 6.62176L13.1721 6.86887C14.4766 6.02193 15.8678 5.40101 17.3007 5.00146L17.8603 3.06063L21.241 3.07133L21.3466 42.1339L17.966 42.1278Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_1752",
    x1: 22.0892,
    y1: -2.91465,
    x2: 22.0892,
    y2: 44.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FB0B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285416,
    stopColor: "#0095D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540625,
    stopColor: "#17428B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709657,
    stopColor: "#E4003A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_1752",
    x1: 22.0892,
    y1: -2.91465,
    x2: 22.0892,
    y2: 44.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FB0B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285416,
    stopColor: "#0095D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540625,
    stopColor: "#17428B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709657,
    stopColor: "#E4003A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6608"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmpowerLogo);
export default __webpack_public_path__ + "static/media/ic_empower_logo.966650adf48d1adef5485835f81d32fe.svg";
export { ForwardRef as ReactComponent };